import { Pipe, PipeTransform } from '@angular/core';
import { DrawerOptions } from '@shared/shared/drawers/common/interfaces/drawer-options';
import { DrawerPlacement } from '@shared/shared/drawers/common/constants/drawer-placement';

@Pipe({
  name: 'drawerDataToAnimationParams',
  standalone: false
})
export class DrawerDataToAnimationParamsPipe implements PipeTransform {
  transform(drawerData: DrawerOptions<any>): Record<string, string> {
    const placement = drawerData.placement;

    switch (placement) {
      case DrawerPlacement.right:
        return {
          hidden: 'translateX(100%)',
          visible: 'translateX(0)'
        };
      case DrawerPlacement.left:
        return {
          hidden: 'translateX(-100%)',
          visible: 'translateX(0)'
        };
      case DrawerPlacement.top:
        return {
          hidden: 'translateY(-100%)',
          visible: 'translateX(0)'
        };
      case DrawerPlacement.bottom:
        return {
          hidden: 'translateY(+100%)',
          visible: 'translateX(0)'
        };
    }
  }
}
